export const SINGLE_ELIMINATION = 1;
export const ARENA = 2;
export const DOUBLE_ELIMINATION = 3;
export const ROUND_ROBIN = 4;
export const MULTILOBBY = 5;
export const TFT = 6;
export const SWISS = 7;
